<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Tax Type"
                v-model="selectedLuExciseTaxTypes.TaxType"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Project Detail ID"
                v-model="selectedLuExciseTaxTypes.ProjectDetailID"
                type="number"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedLuExciseTaxTypes.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveLuExciseTaxTypesDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import LuExciseTaxTypes from '@classes/LuExciseTaxTypes'
//templateTODO: import lookup components you plan to use
export default {
  components: {
    //templateTodo: define lookup components you are using
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuExciseTaxTypes: new LuExciseTaxTypes(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luExciseTaxTypes', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luExciseTaxTypes', ['saveLuExciseTaxTypes']),
    async validate() {
      this.$refs.form.validate()
    },
    editLuExciseTaxTypes(entry) {
      this.selectedLuExciseTaxTypes = new LuExciseTaxTypes(entry)
      this.modalText = 'Edit Tax Types'
      this.dialog = !this.dialog
    },
    addLuExciseTaxTypes() {
      this.modalText = 'Insert Tax Types'
      this.selectedLuExciseTaxTypes = new LuExciseTaxTypes()
      this.dialog = !this.dialog
    },
    saveLuExciseTaxTypesDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveLuExciseTaxTypes(
            this.selectedLuExciseTaxTypes.removeRelated()
          ).then(
            (res) => {
              this.$emit('refresh')
              this.selectedLuExciseTaxTypes = new LuExciseTaxTypes()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuExciseTaxTypes = new LuExciseTaxTypes()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
